<template>
  <div class="wapper" style="padding-bottom:0">
    <div class="about mid-width">
      <div class="title">
        Join US
      </div>
     <div class="about_text">
       <!-- <p>律信网，是一家综合性合伙工作室。律信现有执业律师21名，其中合伙人11名，聘用律师9名，兼职律师1名。律信意为“君子之合，志存高远”，律信人秉承“客户法律利益至上”的原则，汇集了高层次、综合型专业法律人才，以认真严谨的作风，为社会公众提供优质、高效的法律服务是律信人一如既往的承诺。“诚信为本，理法为先”是我们的执业风格。律信律师大多毕业于国内著名法学院或知名大学的法律本科，部份拥有博士或者硕士学位，并拥有资深法官、庭长、高校任教、担任政府公职、企业高层、市律师协会管理等经历和背景，是一支高素质的律师团队。律信律师在刑事、行政、民商事案件中成功代理了大量有社会影响和案例价值的案件，在为客户取得了良好的社会与经济效益的同时，也取得了良好的声誉。对于复杂、疑难的个案，律信集中全所律师的智慧，力求为客户提供最佳、最有效的服务。律信律师在房地产、建筑工程、规划、土地等法律服务领域具有独特的人才和不可替代的专业特色，专业领域内已达到 “人无我有 ”、“独一无二”的高度。不少经典案例已被法院和权威法律文献库选中，奠定了律信同仁深厚的法律服务功底和广博的法律服务经验以及全方位的服务能力。律信同仁在为客户进行全盘精确法律策划、避免法律风险和精心维护合同权益、诉讼策略和技能方面赢得了社会和各界人士的认可。 与此同时，律信同仁以不同方式尽力回报社会，积极参与社会公益活动，为和谐社会、和谐社区贡献绵薄之力。共同的执业理念、规范的管理体系、高素质的法律人才、良好的客户网络，为律信同仁服务客户、服务社会和持续发展奠定了坚实基础。我们承诺，您的委托是正确的选择；我们期待，您能感受我们出色的服务。</p> -->
     </div>
    </div>
    <div class="join_us">
      <div class="mid-width">
          <dl class="clearfix">
            <!-- <dt>合伙人律师招募（10名）</dt>
            <dd>              
              <p>工作地点：北京、上海、广州、深圳、天津、石家庄、沈阳、大连、长春、武汉、长沙、济南、青岛、南京、苏州、杭州、无锡、宁波、厦门 、成都</p>
              <p>发送邮箱：zhanpin@lising.cn</p>
              <p>职位要求：</p>
              <p>（1）具有扎实的法学专业功底、杰出的专业教育背景，知名高校法学本科以上学历，具有硕士、博士以上学历者优先，具有欧美、日韩等海外留学经验者优先；</p>
              <p>（2）已取得律师执业资格证，并具有3年以上律师执业经验，具备明确业务方向，优秀的执业能力，有独立承办某一专业领域案件或非诉讼项目的经验；</p>
              <p>（3）具有政府大型基础工程、政府BOT、国际贸易、风险投资、融资并购、金融证券、保险、海商海事、知识产权、房地产、土地、涉外等业务专长者优先考虑；</p>
              <p>（4）能够独立组建专业法律部门或业务团队，具有较强的组织管理能力和沟通协调能力者优先；</p>
              <p>（5）工作作风严谨、品行端正、具有良好的律师职业操守，遵守律师执业规范；</p>
              <p>（6）具有开拓精神及创新意识，较强的团队合作意识；</p>
              <p>（7）认同律信的发展理念、适应我们的创新发展模式。</p>
            </dd> -->     
          </dl>
          <dl class="clearfix">
            <!-- <dt>专职律师招募（10名）</dt>
            <dd>
              <p>工作地点：北京、上海、广州、深圳、天津、石家庄、沈阳、大连、长春、武汉、长沙、济南、青岛、南京、苏州、杭州、无锡、宁波、厦门 、成都</p>
              <p>发送邮箱：zhanpin@lising.cn</p>
              <p>职位要求：</p>
              <p>（1）具有扎实的法学专业功底、杰出的专业教育背景，知名高校法学本科以上学历，具有硕士、博士以上学历者优先，具有欧美、日韩等海外留学经验者优先；</p>
              <p>（2）已取得律师执业资格证，并具有3年以上律师执业经验，具备明确业务方向，优秀的执业能力，有独立承办某一专业领域案件或非诉讼项目的经验；</p>
              <p>（3）具有政府大型基础工程、政府BOT、国际贸易、风险投资、融资并购、金融证券、保险、海商海事、知识产权、房地产、土地、涉外等业务专长者优先考虑；</p>
              <p>（4）能够独立组建专业法律部门或业务团队，具有较强的组织管理能力和沟通协调能力者优先；</p>
              <p>（5）工作作风严谨、品行端正、具有良好的律师职业操守，遵守律师执业规范；</p>
              <p>（6）具有开拓精神及创新意识，较强的团队合作意识；</p>
              <p>（7）认同律信的发展理念、适应我们的创新发展模式。</p>
            </dd> -->     
          </dl>     
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data () {
      return {

      }
    }
    
  }
</script>
<style lang="scss" scoped>
  @import '~@/common/css/common';
  @import '~@/common/css/news_success';
  .about {
    .title {
      width: 100%;
      height: 250px;
      background: url("./img0.jpg") no-repeat;
      background-size:100% 100%;
      text-align: center;
      line-height: 250px;
      font-size: 48px;
      color: #ffffff;
    }
    .about_text {
      margin-top: 30px;
      p {
        font-size: 15px;
        line-height: 38px;
        color: #333;
        text-indent: 2em;
      }
    }
  }
  .join_us {
    width: 100%;
    padding-top: 30px;
    padding-bottom: 40px;
    background: rgba(245, 245, 245, 1);
    margin: 45px 0 0px;
    font-size: 15px;
    color: #333;
    //height: 500px;
    dl {
      width: 100%;
      line-height: 38px;
      dt {
        font-size: 18px;
        font-weight: bold;
        margin-bottom: 20px;
      }
      margin-bottom: 50px;
    }   
    
  }
</style>





// WEBPACK FOOTER //
// src/components/about/join.vue